/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Thu Nov 23 2023
 **/

import { createContext, useState } from "react";
import { createPortal } from "react-dom";
import BannerWrapper from "./private/BannerWrapper";

interface BannerProvider {
	handlers: {
		handleShow: (content: React.ReactNode) => void;
		handleHide: () => void;
		isShow: () => boolean;
	} | null;
	banner: React.ReactNode | null;
}
export const BannerProvider = createContext<BannerProvider>({
	handlers: null,
	banner: null
});

export default function BannerContainer(props: { children: React.ReactNode }) {
	const [banner, setBanner] = useState<React.ReactNode>(null);

	const handleShow = (content: React.ReactNode) => {
		setBanner(content);
	};

	const handleHide = () => {
		setBanner(null);
	};

	const isShow = () => {
		return banner !== null;
	};

	return (
		<>
			<BannerProvider.Provider
				value={{
					handlers: {
						handleShow,
						handleHide,
						isShow
					},
					banner
				}}
			>
				{props.children}
			</BannerProvider.Provider>
			{banner && createPortal(<BannerWrapper>{banner}</BannerWrapper>, document.body)}
		</>
	);
}
